export const BAR_GRAPH_STARS = 'BAR_GRAPH_STARS';
export const BAR_GRAPH_RATING = 'BAR_GRAPH_RATING';
export const BAR_GRAPH_FIT = 'BAR_GRAPH_FIT';

export const BAR_GRAPH_TYPES = [
    BAR_GRAPH_STARS,
    BAR_GRAPH_RATING,
    BAR_GRAPH_FIT,
];

export const barGraphTypesMap = {
    [BAR_GRAPH_STARS]: {
        type: BAR_GRAPH_STARS,
        useTypeStars: true,
        useTypeRating: false,
        useTypeFit: false,
    },
    [BAR_GRAPH_RATING]: {
        type: BAR_GRAPH_RATING,
        useTypeStars: false,
        useTypeRating: true,
        useTypeFit: false,
    },
    [BAR_GRAPH_FIT]: {
        type: BAR_GRAPH_FIT,
        useTypeStars: false,
        useTypeRating: false,
        useTypeFit: true,
    },
};
